import styled from "styled-components";

export const View = styled.div`
  display: grid;
  place-items: center;
  height: 100vh;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const ContainerMenu = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Roboto;
  color: #a52a2a;
  gap: 20px;
`;
